
<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12">
      <h2 class="txt txt--title"> Buscar licencias eliminadas </h2>
      <small> Podrás revisar la información de licencias eliminadas de un conductor. </small>
    </div>
    <!-- card -->
    <div class="col-md-12 u-mb60">

    <app-person-card
      [personData]="selectedPersonData || {}"
      [boxColor]="personBoxColor"
    >
    </app-person-card>
  <span class="back back--small u-mt10 global-hand" (click)='searchAnotherPerson()'>
    Buscar otra persona
  </span>
</div>

    <div class="col-md-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

